import { Stack, Typography } from '@mui/material'
import { motion } from 'framer-motion'
import IA_1 from '../../../assets/animation/IA_1.svg'
import IA_2 from '../../../assets/animation/IA_2.svg'
import IA_3 from '../../../assets/animation/IA_3.svg'
import IA_4 from '../../../assets/animation/IA_4.svg'
import IA_5 from '../../../assets/animation/IA_5.svg'

const images = [IA_1, IA_2, IA_3, IA_4, IA_5]

const positions = [
  { top: '5.4rem', left: '1.8rem', width: '1.35rem' },
  { top: '5.85rem', left: '3.6rem', width: '1.35rem' },
  { top: '3.6rem', left: '5.4rem', width: '1.35rem' },
  { top: '0.9rem', left: '7.2rem', width: '1.35rem' },
  { top: '1.8rem', left: '9rem', width: '1.35rem' },
]

const LoadingDash = ({ title }: { title: string }) => (
  <Stack direction="column" spacing={2.16} alignItems="center">
    <Stack direction="row" sx={{ position: 'relative', width: '13.5rem', height: '9rem' }}>
      {images.map((src, i) => (
        <motion.img
          key={i}
          src={src}
          alt={`Bar ${i + 1}`}
          initial={{ y: 0 }}
          animate={{ y: ['0rem', '-2.16rem', '0rem'] }}
          transition={{
            duration: 1.2,
            repeat: Infinity,
            ease: 'easeInOut',
            delay: i * 0.2,
          }}
          style={{
            position: 'absolute',
            ...positions[i],
          }}
        />
      ))}
    </Stack>
    <Typography variant="subtitle1">{title}</Typography>
  </Stack>
)

export default LoadingDash
